import styled from 'styled-components';
import { Typography } from 'antd';

const { Text, Title } = Typography;

export const VideoPlayerWrapper = styled.div`
	width: 100%;
	aspect-ratio: 16/9;
	background-color: #f8f8f8;
	border-radius: 16px;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 2px 2px 8px 0px rgba(0, 0, 0, 0.25);
	overflow: hidden;
`;

export const VideoTitle = styled(Title)`
	&& {
		margin: 0;
		font-size: 25px;
		font-weight: 600;
		line-height: 32px;
		letter-spacing: -0.125px;
		color: #262626;
		word-break: break-word;
		overflow-wrap: break-word;
		max-width: 100%;
	}
`;

export const VideoInfoText = styled(Text)`
	&& {
		font-size: 18px;
		line-height: 24px;
		color: #262626;
	}
`;

export const VideoInfoLabel = styled(Text)`
	&& {
		font-size: 18px;
		line-height: 24px;
		font-weight: 600;
	}
`;

export const VideoInfoCol = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-width: 0;
	gap: 24px;
`;
